import { cloneElement, useMemo, type ReactElement } from 'react';
import { getAAIcon } from '../../assets/aa';
import { useWalletConnections } from '../../hooks/useWalletConnections';
import { StyleAAWrapper, StyleCMWrapper, StyleWalletIconContainer } from '../walletIcon/styles';
const WalletIcon = ({ size = 20, aaName = '' }: { size?: number; aaName?: string }) => {
  const [walletConnection] = useWalletConnections();

  const cmSize = useMemo(() => {
    return Math.floor(size / 1.6);
  }, [size]);

  const AAIcon = getAAIcon(aaName);

  return (
    <StyleWalletIconContainer width={size} height={size}>
      <StyleAAWrapper key={aaName}>
        <AAIcon />
        <StyleCMWrapper width={cmSize} height={cmSize}>
          {
            (walletConnection?.walletProps.icon &&
              cloneElement(
                walletConnection?.walletProps.icon as ReactElement,
                {
                  width: cmSize,
                  height: cmSize,
                } as any
              )) as any
          }
        </StyleCMWrapper>
      </StyleAAWrapper>
    </StyleWalletIconContainer>
  );
};

export default WalletIcon;
